import { useState, useRef } from 'react'
import { DataTable } from './DataTable'
import { Form, Button, message, Modal } from 'antd'
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhBox } from '@/components/YhBox'
import { YHModal } from "@/components/YHModal";
import { YhForm } from "@/components/YhFormBox";
import { detailModel } from './detailModel';
import { totalModel } from '../total/totalModel';
import { settleService } from '../../settleService'
import useGlobalModel from "@/model/globalModel";

export const DataBox = () => {

    const { user } = useGlobalModel();
    const {
        loadData, statistics,
        selectedRowKeys, setSelectedRowKeys,
        selectedData, setSelectedData,
        formValues, setFormValues
    } = detailModel();
    const { franchiseeCode, selected } = totalModel();

    const formRef = useRef<IYhFormRef>();
    const [form] = Form.useForm();
    const [visible, setVisible] = useState<boolean>(false);
    const [settlementAmount, setSettlementAmount] = useState<number>(0);

    const action = (
        <>
            <Button
                shape="round"
                type="primary"
                onClick={() => {
                    if (selectedRowKeys.length == 0) {
                        message.warning("请选择需要结算的数据！")
                        return
                    }
                    getSettlementAmount();
                    setVisible(true);
                }}>
                发起结算
            </Button>
        </>
    )

    const getSettlementAmount = async () => {
        const params = {
            "searchItem": {
                "ids": selectedData.map(item => item.id),
                "franchiseeCode": franchiseeCode
            },
            "pageSize": "10",
            "pageNum": "1",
        }
        const { retData } = await settleService.settlementAmount(params);
        const data = retData.filter(e => e.fieldCode === "billSettlementAmount")?.[0];
        setFormValues({
            "franchiseeName": selected.franchiseeName,
            "num": selectedRowKeys.length,
            "amount": data.fieldValue ?? 0
        });
        setSettlementAmount(data.fieldValue ?? 0);
    };

    const onChange = (changedValues: { [key: string]: any }) => {
        setFormValues({ ...formValues, ...changedValues });
    }

    const formConfig: IYhForm = {
        labelCol: { span: 6 },
        formValues: formValues,
        onChange,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账单编号",
                fieldName: "code",
                span: 24,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "加盟商名称",
                fieldName: "franchiseeName",
                span: 24,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "工单数量",
                fieldName: "num",
                span: 24,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账单金额",
                fieldName: "amount",
                span: 24,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账单备注",
                fieldName: "note",
                span: 24,
            },
        ]
    };

    const onSubmit = () => {
        Modal.confirm({
            title: '系统确认',
            centered: true,
            closable: true,
            content: <div>确定要发起结算?</div>,
            onOk() {
                const params = {
                    "partnerCode": franchiseeCode,
                    "partnerName": selected.franchiseeName,
                    "billAmount": formValues.amount,
                    "note": formValues.note,
                    "num": formValues.num,
                    "fixedCreateTime": selected.fixedCreateTime,
                    "fixedEndTime": selected.fixedEndTime,
                    "billOrderList": selectedData.map(item => {
                        return {
                            "orderId": item.id,
                            "customerName": item.customerName,
                            "tradeCode": item.orderCode,
                            "orderCreateTime": item.orderCompletedTime,
                            "amount": item.orderActualAmount,
                            "writeoffUser": user?.userName,
                        }
                    })
                }
                settleService.billInsert(params).then((res) => {
                    if (res && res.success) {
                        setSelectedRowKeys([]);
                        setSelectedData([]);
                        loadData();
                        message.success("操作成功");
                    }
                    else {
                        message.error("操作失败")
                    }
                    setVisible(false);
                }).catch((err) => {
                    message.error("请求失败" + err)
                })
            },
        })
    }

    return (
        <>
            <YhBox title="" action={action} style={{ height: 'calc(100vh - 185px)', padding: '10px 0px 0px 0px' }}>
                <div style={{ color: 'red', fontWeight: 'bold', float: 'right' }}>
                    {statistics?.map(item => {
                        return <><span style={{ marginRight: 10 }}>{item.fieldName}:</span><span style={{ marginRight: 20 }}>{item.fieldValue}</span></>
                    })}
                </div>
                <DataTable />
            </YhBox>

            <YHModal
                visible={visible}
                onOk={onSubmit}
                onCancel={() => setVisible(false)}
                title="发起结算提醒"
                width={400} height={400}
                showFooter={true}>
                <div style={{ padding: 10 }}>
                    <Form form={form} component={false}>
                        <YhForm formRef={formRef} {...formConfig} />
                    </Form>
                </div>
            </YHModal>
        </>

    )
}
